import { LocationQuery } from 'vue-router';
import { cacheFirstConfig, http } from '../../helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { Salutation } from './salutation.interface';

export class SalutationService {
   async getSalutations(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Salutation>>>(`/salutations`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
